/** Shared copy + field styling for Store Settings (no UI components). */

export const MAX_SEARCH_KEYWORDS = 10;
/** Total pickup free-item rows (1 fixed none/none + 3 user-editable slots). */
export const MAX_PICKUP_FREE_ITEMS = 4;
export const PICKUP_FREE_RESERVED_ROW = { name: 'none', size: 'none' };

export const STORE_SETTINGS_CONFIRMATION_TEXT =
  'By saving these store settings, you confirm the information is accurate and that details you ' +
  'provide—including store profile, hours, images, delivery and pickup options, and promotions—may ' +
  'be shown to customers or used to operate your kitchen on the platform. Content must not be ' +
  'harmful, misleading, or inappropriate. Violations may result in removal of content or further ' +
  'account action.';

export const SS_OUTLINED_INPUT = 'custom-css-outlined-input';

export const ssFieldSx = {
  width: '100%',
  '& .MuiInputBase-input': { fontSize: '14px', textTransform: 'capitalize' },
};

export const ssReadOnlyFieldSx = {
  ...ssFieldSx,
  '& .MuiOutlinedInput-root': { backgroundColor: '#f9fafb' },
  '& .MuiInputBase-input': { fontSize: '14px', opacity: 0.85 },
};

export const ssAddRowButtonSx = {
  mt: 1.5,
  color: 'rgb(24, 20, 54)',
  backgroundColor: '#EAEFEF',
  fontSize: 12,
  '&:hover': {
    backgroundColor: 'rgb(24, 20, 54)',
    color: 'white',
  },
};

export const grid2 = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '16px 20px',
  width: '100%',
};

export const ssBannerCode = {
  fontSize: 13,
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  background: '#fff3e0',
  padding: '2px 6px',
  borderRadius: 4,
  color: '#7a4a00',
  fontWeight: 600,
};

/** Single-slot fields inside `store_front_images` (excludes `store_logo_url`, which uses the legacy Store logo uploader above, and the "Your Pick" trio, which share one section — see `YOUR_PICK_IMAGE_SECTION`). */
export const STORE_FRONT_IMAGE_FIELDS = [
  {
    key: 'splash_ad_image_url',
    label: 'Splash ad image',
    description: 'Full-screen promotional ad shown to customers.',
  },
  {
    key: 'store_menu_banner_image_url',
    label: 'Store menu banner image',
    description: 'Banner displayed at the top of your store menu page.',
  },
  {
    key: 'scanned_for_you_image_url',
    label: 'Scanned for you image',
    description: 'Shown in the "Scanned for you" section on your store profile.',
  },
];

/** The 3 "Your Pick" slots inside `store_front_images`, rendered together as one section. */
export const YOUR_PICK_IMAGE_SECTION = {
  title: 'Your Pick images',
  description: 'Shown in the "Your Pick" promo carousel on your store profile.',
  fields: [
    { key: 'your_pick_image_one_url', label: 'Image 1' },
    { key: 'your_pick_image_two_url', label: 'Image 2' },
    { key: 'your_pick_image_three_url', label: 'Image 3' },
  ],
};

export const DELIVERY_TYPE_OPTIONS = [
  { value: 'both', label: 'Home delivery & pickup' },
  { value: 'home delivery', label: 'Home delivery only' },
  { value: 'pickup', label: 'Pickup only' },
];

export const WEEKDAY_OPTIONS = [
  { value: null, label: 'None' },
  { value: 'monday', label: 'Monday' },
  { value: 'tuesday', label: 'Tuesday' },
  { value: 'wednesday', label: 'Wednesday' },
  { value: 'thursday', label: 'Thursday' },
  { value: 'friday', label: 'Friday' },
  { value: 'saturday', label: 'Saturday' },
  { value: 'sunday', label: 'Sunday' },
];

/** `food_filter_categories` checkbox options. */
export const FOOD_FILTER_CATEGORY_OPTIONS = [
  'fast food',
  'pizza',
  'hot dogs',
  'tacos',
  'fried chicken',
  'wings',
  'bbq & grill',
  'breakfast',
  'sandwiches',
  'seafood',
  'smoothies',
  'desserts & bakery',
  'coffee & drinks',
  'chinese',
  'mediterranean',
  'mexican',
  'middle eastern',
  'asian',
  'italian',
  'korean',
];

/** `religious_filter_categories` checkbox options. */
export const RELIGIOUS_FILTER_CATEGORY_OPTIONS = ['halal', 'kosher', 'vegan', 'vegetarian'];

/** `comboMenuLabelName` enum — sent to the backend verbatim (lowercase); UI shows Capitalized text. */
export const COMBO_MENU_LABEL_OPTIONS = [
  'combo menu',
  'lunch combo',
  'brunch combo',
  'dinner combo',
  'family combo',
  'party combo',
  'meal combo',
];
